import React from 'react';

import { badge, compact as compactClass, icon } from './ai-image-badge.module.scss';
import SparkleIcon from '../../assets/images/svg/icon-ai-sparkle.svg';

interface IAiImageBadgeProps {
    className?: string;
    compact?: boolean;
}

const AiImageBadge: React.FC<IAiImageBadgeProps> = ({ className = '', compact = false }) => {
    return (
        <span className={`${badge} ${compact ? compactClass : ''} ${className}`}>
            <SparkleIcon className={icon} aria-hidden="true" />
            {compact ? 'Grafika AI' : 'Grafika wygenerowana przez AI'}
        </span>
    );
};

export default AiImageBadge;
